import { Route, Routes } from 'react-router-dom';
import './App.css';
import About from './Components/About';
import AcceptableUsePolicy from './Components/AcceptableUsePolicy';
import Contact from './Components/Contact';
import DataProcessingAddendum from './Components/DataProcessingAddendum';
import Footer from './Components/Footer';
import Home from './Components/Home';
import NavBar from './Components/Navbar';
import Pricing from './Components/Pricing';
import PrivacyPolicy from './Components/PrivacyPolicy';
import Products from './Components/Products';
import ScrollToTop from './Components/ScrollToTop';
import Services from './Components/Services';
import SubscriptionAgreement from './Components/SubscriptionAgreement';

function App() {
  return (
    <>
      <ScrollToTop />
      <NavBar />
      <main className="page-body">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/services" element={<Services />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal/subscription-agreement" element={<SubscriptionAgreement />} />
          <Route path="/legal/data-processing-addendum" element={<DataProcessingAddendum />} />
          <Route path="/legal/acceptable-use" element={<AcceptableUsePolicy />} />
          <Route path="/legal/privacy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;
